module.exports = __webpack_public_path__ + "img/clienti-petrom.7784f53a.jpg";